// generated by genversion
module.exports = '2.5.0'



/*****************
 ** WEBPACK FOOTER
 ** ./~/tough-cookie/lib/version.js
 ** module id = 944
 ** module chunks = 0
 **/